const routes = [
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        meta: { title: 'pages.home.title', anonymous: true },
      },
      {
        path: '/gmail',
        name: 'home2',
        component: () => import('@/views/Home.vue'),
        meta: { title: 'pages.home.title', anonymous: true },
      },
      {
        path: '/test',
        name: 'test',
        component: () => import('@/views/test/List.vue'),
        meta: { title: 'Test', anonymous: true },
      },
      {
        path: '/login',
        name: 'login',
        meta: { title: 'pages.login.title' },
        component: () => import('@/views/Login.vue'),
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        meta: {
          title: 'pages.dashboard.title',
          state: 'authorized',
        },
        component: () => import('@/views/Dashboard.vue'),
      },
      // Admin
      {
        path: '/admin',
        name: 'admin',
        meta: {
          title: 'pages.admin.title',
          state: 'authorized',
        },
        component: () => import('@/views/admin/Admin.vue'),
      },
      // Photo download
      {
        path: '/admin/photosDownloadZip',
        name: 'photosDownloadZip',
        meta: {
          title: 'Personu fotogrāfiju lejupielāde',
          state: 'authorized',
        },
        component: () => import('@/views/admin/photos/Download.vue'),
      },
      // Lomas
      {
        path: '/admin/user-roles',
        name: 'users',
        meta: {
          title: 'pages.admin.users.title',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
          ],
        },
        component: () => import('@/views/admin/users/List.vue'),
      },
      {
        path: '/admin/user-role/:itemCode/edit',
        name: 'userRoleEdit',
        meta: {
          title: 'pages.admin.usersRoles.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.admin.users.title',
              to: { name: 'users' },
            },
          ],
        },
        component: () => import('@/views/admin/users/Edit.vue'),
      },
      {
        path: '/admin/user-role/:itemCode/view',
        name: 'userRoleView',
        meta: {
          title: 'pages.admin.viewTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.admin.users.title',
              to: { name: 'users' },
            },
          ],
        },
        component: () => import('@/views/admin/users/View.vue'),
      },
      {
        path: '/admin/user-role/new',
        name: 'userRoleNew',
        meta: {
          title: 'pages.admin.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.admin.users.title',
              to: { name: 'users' },
            },
          ],
        },
        component: () => import('@/views/admin/users/New.vue'),
      },
      {
        path: '/collectives/:collectiveId/add-admin',
        name: 'collectives.newAdmin',
        meta: {
          title: 'pages.admin.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.collectives.title',
              to: {
                name: 'collectives',
                state: { restorePaging: true },
              },
            },
            // {
            //   text: 'pages.collectives.viewTitle',
            //   to: {
            //     name: 'collectiveView',
            //     params: (route) => ({
            //       itemCode: Number(route.params.collectiveId),
            //       restorePaging: 'true',
            //     }),
            //   },
            // },
          ],
        },
        component: () => import('@/views/admin/users/New.vue'),
      },
      // ID Kartes
      {
        path: '/cards',
        name: 'cards',
        meta: {
          title: 'pages.cards.title',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
          ],
        },
        component: () => import('@/views/admin/cards/List.vue'),
      },
      {
        path: '/card/:itemCode/view',
        name: 'cardView',
        meta: {
          title: 'pages.cards.viewTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.cards.title',
              to: { name: 'cards' },
            },
          ],
        },
        component: () => import('@/views/admin/cards/View.vue'),
      },
      // Norises vietas
      {
        path: '/venues',
        name: 'venues',
        meta: {
          title: 'pages.venues.title',
          state: 'authorized',
        },
        component: () => import('@/views/registries/venues/List.vue'),
      },
      {
        path: '/venue/:venueId/view',
        name: 'venueView',
        meta: {
          title: 'pages.venues.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.venues.title',
              to: { name: 'venues' },
            },
          ],
        },
        component: () => import('@/views/registries/venues/View.vue'),
      },
      {
        path: '/venue/:venueId/edit',
        name: 'venueEdit',
        meta: {
          title: 'pages.venues.title',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.venues.title',
              to: { name: 'venues' },
            },
          ],
        },
        component: () => import('@/views/registries/venues/Edit.vue'),
      },
      {
        path: '/venues/new',
        name: 'venuesNew',
        meta: {
          title: 'pages.venues.newTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.venues.title',
              to: { name: 'venues' },
            },
          ],
        },
        component: () => import('@/views/registries/venues/New.vue'),
      },
      // Skatuves
      {
        path: '/venue/:venueId/stage/new',
        name: 'stageNew',
        meta: {
          title: 'pages.venues.stages.labels.newTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.venues.title',
              to: { name: 'venues' },
            },
            {
              text: 'pages.venues.titleSingular',
              to: { name: 'venueView', params: (route) => ({ venueId: route.params.venueId }) },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/venues/stages/New.vue'),
      },
      {
        path: '/venue/:venueId/stage/:itemCode/view',
        name: 'stageView',
        meta: {
          title: 'pages.venues.stages.viewTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.venues.title',
              to: { name: 'venues' },
            },
            {
              text: 'pages.venues.titleSingular',
              to: { name: 'venueView', params: (route) => ({ venueId: route.params.venueId }) },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/venues/stages/View.vue'),
      },
      {
        path: '/venue/:venueId/stage/:itemCode/edit',
        name: 'stageEdit',
        meta: {
          title: 'pages.venues.stages.viewTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.venues.title',
              to: { name: 'venues' },
            },
            {
              text: 'pages.venues.titleSingular',
              to: { name: 'venueView', params: (route) => ({ venueId: route.params.venueId }) },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/venues/stages/Edit.vue'),
      },
      // Kontroles zonas
      {
        path: '/venue/:venueId/controlZone/new',
        name: 'controlZoneNew',
        meta: {
          title: 'pages.venues.title',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.venues.title',
              to: { name: 'venues' },
            },
          ],
        },
        component: () => import('@/views/registries/venues/controlZones/New.vue'),
      },
      {
        path: '/venue/:venueId/controlZone/:itemCode/view',
        name: 'controlZoneView',
        meta: {
          title: 'pages.venues.title',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.venues.title',
              to: { name: 'venues' },
            },
          ],
        },
        component: () => import('@/views/registries/venues/controlZones/View.vue'),
      },
      {
        path: '/venue/:venueId/controlZone/:itemCode/edit',
        name: 'controlZoneEdit',
        meta: {
          title: 'pages.venues.title',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.venues.title',
              to: { name: 'venues' },
            },
          ],
        },
        component: () => import('@/views/registries/venues/controlZones/Edit.vue'),
      },
      // Piesaistītās ēdināšanas vietas
      {
        path: '/venue/:venueId/connectedVenues/new',
        name: 'connectedVenueNew',
        meta: {
          title: 'pages.venues.title',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.venues.title',
              to: { name: 'venues' },
            },
          ],
        },
        component: () => import('@/views/registries/venues/connectedVenues/New.vue'),
      },
      {
        path: '/venue/:venueId/connectedVenue/:itemCode/view',
        name: 'connectedVenueView',
        meta: {
          title: 'pages.venues.title',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.venues.title',
              to: { name: 'venues' },
            },
          ],
        },
        component: () => import('@/views/registries/venues/connectedVenues/View.vue'),
      },
      // Notikumi
      {
        path: '/events',
        name: 'events',
        meta: {
          title: 'pages.events.title',
          state: 'authorized',
        },
        component: () => import('@/views/registries/events/List.vue'),
      },
      {
        path: '/events/:eventId/view',
        name: 'eventView',
        meta: {
          title: 'pages.events.viewTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: {
                name: 'events',
                state: { restorePaging: true },
              },
            },
          ],
        },
        component: () => import('@/views/registries/events/View.vue'),
      },
      {
        path: '/events/:eventId/edit',
        name: 'eventEdit',
        meta: {
          title: 'pages.events.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
          ],
        },
        component: () => import('@/views/registries/events/Edit.vue'),
      },
      {
        path: '/events/new',
        name: 'eventsNew',
        meta: {
          title: 'pages.events.newTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
          ],
        },
        component: () => import('@/views/registries/events/New.vue'),
      },
      {
        path: '/event/:eventId/subEvents',
        name: 'subEvents',
        meta: {
          title: 'pages.events.subEvents.title',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
          ],
        },
        component: () => import('@/views/registries/events/subEvents/List.vue'),
      },
      {
        path: '/event/:eventId/subEvent/:subEventId/view',
        name: 'subEventView',
        meta: {
          title: 'pages.events.subEvents.viewTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
            {
              text: 'pages.events.viewTitle',
              to: {
                name: 'eventView',
                params: (route) => ({ eventId: route.params.eventId }),
              },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/events/subEvents/View.vue'),
      },
      {
        path: '/event/:eventId/subEvent/:subEventId/edit',
        name: 'subEventEdit',
        meta: {
          title: 'pages.events.subEvents.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
            {
              text: 'pages.events.viewTitle',
              to: {
                name: 'eventView',
                params: (route) => ({ eventId: route.params.eventId }),
              },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/events/subEvents/Edit.vue'),
      },
      {
        path: '/event/:eventId/subEvent/new',
        name: 'subEventsNew',
        meta: {
          title: 'pages.events.subEvents.newTitleSimple',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
            {
              text: 'pages.events.viewTitle',
              to: {
                name: 'eventView',
                params: (route) => ({ eventId: route.params.eventId }),
              },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/events/subEvents/New.vue'),
      },
      {
        path: '/event/:eventId/newParticipation',
        name: 'newParticipationCollective',
        meta: {
          title: 'pages.events.newCollectiveTitleSimple',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
            {
              text: 'pages.events.viewTitle',
              to: {
                name: 'eventView',
                params: (route) => ({ eventId: route.params.eventId }),
              },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/events/participation/New.vue'),
      },
      {
        path: '/event/:eventId/participation/:itemCode/view',
        name: 'participationCollectiveView',
        meta: {
          title: 'pages.events.viewCollectiveTitleSimple',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
            {
              text: 'pages.events.viewTitle',
              to: {
                name: 'eventView',
                params: (route) => ({ eventId: route.params.eventId }),
              },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/events/participation/View.vue'),
      },
      {
        path: '/event/:eventId/participation/:itemCode/edit',
        name: 'participationCollectiveEdit',
        meta: {
          title: 'pages.events.editCollectiveTitleSimple',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
            {
              text: 'pages.events.viewTitle',
              to: {
                name: 'eventView',
                params: (route) => ({ eventId: route.params.eventId }),
              },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/events/participation/Edit.vue'),
      },
      {
        path: '/event/:eventId/subEvent/:subEventId/schedule/:itemCode/view',
        name: 'scheduleView',
        meta: {
          title: 'pages.events.schedule.viewTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
            {
              text: 'pages.events.viewTitle',
              to: {
                name: 'eventView',
                params: (route) => ({ eventId: route.params.eventId }),
              },
              overridable: true,
            },
            {
              text: 'pages.events.subEvents.titleSingular',
              to: {
                name: 'subEventView',
                params: (route) => ({ subEventId: route.params.subEventId }),
              },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/events/schedule/View.vue'),
      },
      {
        path: '/event/:eventId/subEvent/:subEventId/schedule/:itemCode/edit',
        name: 'scheduleEdit',
        meta: {
          title: 'pages.events.schedule.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
            {
              text: 'pages.events.viewTitle',
              to: {
                name: 'eventView',
                params: (route) => ({ eventId: route.params.eventId }),
              },
              overridable: true,
            },
            {
              text: 'pages.events.subEvents.titleSingular',
              to: {
                name: 'subEventView',
                params: (route) => ({ subEventId: route.params.subEventId }),
              },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/events/schedule/Edit.vue'),
      },
      {
        path: '/event/:eventId/subEvent/:subEventId/schedule/new',
        name: 'scheduleNew',
        meta: {
          title: 'pages.events.schedule.newTitleSimple',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
            {
              text: 'pages.events.viewTitle',
              to: {
                name: 'eventView',
                params: (route) => ({ eventId: route.params.eventId }),
              },
              overridable: true,
            },
            {
              text: 'pages.events.subEvents.titleSingular',
              to: {
                name: 'subEventView',
                params: (route) => ({ subEventId: route.params.subEventId }),
              },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/events/schedule/New.vue'),
      },
      {
        path: '/event/:eventId/subEvent/:subEventId/schedule/:itemCode/addCollective',
        name: 'newScheduleCollective',
        meta: {
          title: 'pages.events.schedule.newCollectiveTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
          ],
        },
        component: () => import('@/views/registries/events/schedule/NewCollective.vue'),
      },
      {
        path: '/event/:eventId/subEvent/:subEventId/participation/:itemCode/view',
        name: 'subEventParticipationCollectiveView',
        meta: {
          title: 'pages.events.subEvents.viewCollectiveTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
            {
              text: 'pages.events.viewTitle',
              to: {
                name: 'eventView',
                params: (route) => ({ eventId: route.params.eventId }),
              },
              overridable: true,
            },
            {
              text: 'pages.events.subEvents.titleSingular',
              to: {
                name: 'subEventView',
                params: (route) => ({ subEventId: route.params.subEventId }),
              },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/events/subEvents/participation/View.vue'),
      },
      {
        path: '/event/:eventId/subEvent/:subEventId/participation/:itemCode/edit',
        name: 'subEventParticipationCollectiveEdit',
        meta: {
          title: 'pages.events.subEvents.viewCollectiveTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
            {
              text: 'pages.events.viewTitle',
              to: {
                name: 'eventView',
                params: (route) => ({ eventId: route.params.eventId }),
              },
              overridable: true,
            },
            {
              text: 'pages.events.subEvents.titleSingular',
              to: {
                name: 'subEventView',
                params: (route) => ({ subEventId: route.params.subEventId }),
              },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/events/subEvents/participation/Edit.vue'),
      },
      {
        path: '/event/:eventId/subEvent/:subEventId/participation/new',
        name: 'subEventParticipationCollectiveNew',
        meta: {
          title: 'pages.events.subEvents.newCollectiveTitleSimple',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.events.title',
              to: { name: 'events', state: { restorePaging: true } },
            },
            {
              text: 'pages.events.viewTitle',
              to: {
                name: 'eventView',
                params: (route) => ({ eventId: route.params.eventId }),
              },
              overridable: true,
            },
            {
              text: 'pages.events.subEvents.titleSingular',
              to: {
                name: 'subEventView',
                params: (route) => ({ subEventId: route.params.subEventId }),
              },
              overridable: true,
            },
          ],
        },
        component: () => import('@/views/registries/events/subEvents/participation/New.vue'),
      },
      // Paziņojumi
      {
        path: '/notifications',
        name: 'notifications',
        meta: {
          title: 'pages.notifications.title',
          state: 'authorized',
        },
        component: () => import('@/views/registries/notifications/List.vue'),
      },
      {
        path: '/notification/:itemCode/view',
        name: 'notificationView',
        meta: {
          title: 'pages.notifications.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.notifications.title',
              to: { name: 'notifications' },
            },
          ],
        },
        component: () => import('@/views/registries/notifications/View.vue'),
      },

      // E-paziņojumi
      {
        path: '/enotifications',
        name: 'eNotifications',
        meta: {
          title: 'pages.eNotifications.title',
          state: 'authorized',
        },
        component: () => import('@/views/registries/notifications/List.vue'),
      },
      {
        path: '/enotification/:itemCode/view',
        name: 'eNotificationView',
        meta: {
          title: 'pages.eNotifications.viewTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.eNotifications.title',
              to: { name: 'eNotifications', state: { restorePaging: true } },
            },
          ],
        },
        component: () => import('@/views/registries/notifications/View.vue'),
      },
      {
        path: '/enotification/new',
        name: 'eNotificationsNew',
        meta: {
          title: 'pages.eNotifications.newTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.eNotifications.title',
              to: { name: 'eNotifications', state: { restorePaging: true } },
            },
          ],
        },
        component: () => import('@/views/registries/notifications/View.vue'),
      },

      // Aproces
      {
        path: '/wristbands',
        name: 'wristbands',
        meta: {
          title: 'pages.wristbands.title',
          state: 'authorized',
        },
        component: () => import('@/views/registries/wristbands/List.vue'),
      },
      {
        path: '/wristband/:itemCode/view',
        name: 'wristbandView',
        meta: {
          title: 'pages.wristbands.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.wristbands.title',
              to: { name: 'wristbands' },
            },
          ],
        },
        component: () => import('@/views/registries/wristbands/View.vue'),
      },
      {
        path: '/wristband/:itemCode/edit',
        name: 'wristbandEdit',
        meta: {
          title: 'pages.wristbands.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.wristbands.title',
              to: { name: 'wristbands' },
            },
          ],
        },
        component: () => import('@/views/registries/wristbands/Edit.vue'),
      },
      {
        path: '/wristband/new',
        name: 'wristbandNew',
        meta: {
          title: 'pages.wristbands.newTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.wristbands.title',
              to: { name: 'wristbands' },
            },
          ],
        },
        component: () => import('@/views/registries/wristbands/New.vue'),
      },
      // Reģistri
      {
        path: '/registries',
        name: 'registries',
        meta: {
          title: 'pages.registries.title',
          state: 'authorized',
        },
        component: () => import('@/views/registries/List.vue'),
      },
      // KLASIFIKATORI
      {
        path: '/classifiers',
        name: 'classifiers',
        meta: {
          title: 'pages.classifiers.title',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
          ],
        },
        component: () => import('@/views/classifiers/List.vue'),
      },
      {
        path: '/classifiers/:classifierCode',
        name: 'classifier',
        meta: {
          title: 'pages.classifiers.title',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
          ],
        },
        component: () => import('@/views/classifiers/SingleList.vue'),
      },
      // Gājiena grupas
      {
        path: '/classifiers/marchGroups',
        name: 'classifierMarchGroups',
        meta: {
          title: 'pages.classifiers.types.marchGroups',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
          ],
        },
        component: () => import('@/views/classifiers/marchGroups/List.vue'),
      },
      // Dalībnieku grupas
      {
        path: '/classifiers/participantGroups',
        name: 'classifierParticipantGroups',
        meta: {
          title: 'pages.classifiers.types.participantGroups',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
          ],
        },
        component: () => import('@/views/classifiers/participantGroups/List.vue'),
      },
      // Kolektīva kategorijas
      {
        path: '/classifiers/collectiveMarks',
        name: 'classifierCollectiveMarks',
        meta: {
          title: 'pages.classifiers.types.KKP',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
          ],
        },
        component: () => import('@/views/classifiers/collectiveMarks/List.vue'),
      },

      // Vērtējuma grupas / Kvalifikācijas grupas / Veidi/grupas
      {
        path: '/classifiers/ratingGroups',
        name: 'classifierRatingGroups',
        meta: {
          title: 'pages.classifiers.types.KVG',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
          ],
        },
        component: () => import('@/views/classifiers/ratingGroups/List.vue'),
      },

      // Pašvaldības
      {
        path: '/classifiers/municipalities',
        name: 'classifierMunicipalities',
        meta: {
          title: 'pages.classifiers.types.municipalities',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
          ],
        },
        component: () => import('@/views/classifiers/municipalities/List.vue'),
      },
      {
        path: '/classifiers/municipalities/:itemCode/edit',
        name: 'municipalityEdit',
        meta: {
          title: 'pages.classifiers.types.municipalitiesEdit',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
            {
              text: 'pages.classifiers.types.municipalities',
              to: { name: 'classifierMunicipalities', state: { restorePaging: true } },
            },
          ],
        },
        component: () => import('@/views/classifiers/municipalities/Edit.vue'),
      },
      {
        path: '/classifiers/municipalities/:itemCode/view',
        name: 'municipalityView',
        meta: {
          title: 'pages.classifiers.types.municipality',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
            {
              text: 'pages.classifiers.types.municipalities',
              to: { name: 'classifierMunicipalities', state: { restorePaging: true } },
            },
          ],
        },
        component: () => import('@/views/classifiers/municipalities/View.vue'),
      },
      {
        path: '/classifiers/municipalities/new',
        name: 'municipalityNew',
        meta: {
          title: 'pages.classifiers.types.municipalityNew',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
            {
              text: 'pages.classifiers.types.municipalities',
              to: { name: 'classifierMunicipalities', state: { restorePaging: true } },
            },
          ],
        },
        component: () => import('@/views/classifiers/municipalities/New.vue'),
      },
      // Burti
      {
        path: '/classifiers/letters',
        name: 'classifierLetters',
        meta: {
          title: 'pages.classifiers.types.letters',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
          ],
        },
        component: () => import('@/views/classifiers/letters/List.vue'),
      },
      {
        path: '/classifiers/letters/:itemCode/edit',
        name: 'letterEdit',
        meta: {
          title: 'pages.classifiers.types.lettersEdit',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
            {
              text: 'pages.classifiers.types.letters',
              to: { name: 'classifierLetters' },
            },
          ],
        },
        component: () => import('@/views/classifiers/letters/Edit.vue'),
      },
      {
        path: '/classifiers/letters/:itemCode/view',
        name: 'letterView',
        meta: {
          title: 'pages.classifiers.types.lettersEdit',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
            {
              text: 'pages.classifiers.types.letters',
              to: { name: 'classifierLetters' },
            },
          ],
        },
        component: () => import('@/views/classifiers/letters/View.vue'),
      },
      {
        path: '/classifiers/letters/new',
        name: 'letterNew',
        meta: {
          title: 'pages.classifiers.types.lettersEdit',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
            {
              text: 'pages.classifiers.types.letters',
              to: { name: 'classifierLetters' },
            },
          ],
        },
        component: () => import('@/views/classifiers/letters/New.vue'),
      },
      // Krāsas
      {
        path: '/classifiers/colors',
        name: 'classifierColors',
        meta: {
          title: 'pages.classifiers.types.colors',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
          ],
        },
        component: () => import('@/views/classifiers/colors/List.vue'),
      },
      // Norišu veidi
      {
        path: '/classifiers/subEventTypes',
        name: 'classifierSubEventTypes',
        meta: {
          title: 'pages.classifiers.types.subEventTypes',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
          ],
        },
        component: () => import('@/views/classifiers/subEvents/List.vue'),
      },
      // Nozares
      {
        path: '/classifiers/industries',
        name: 'classifierIndustries',
        meta: {
          title: 'pages.classifiers.types.KN',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
          ],
        },
        component: () => import('@/views/classifiers/industries/List.vue'),
      },
      // Valstis
      {
        path: '/classifiers/countries',
        name: 'classifierCountries',
        meta: {
          title: 'pages.classifiers.types.countries',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
          ],
        },
        component: () => import('@/views/classifiers/countries/List.vue'),
      },
      {
        path: '/classifiers/countries/:itemCode/edit',
        name: 'countryEdit',
        meta: {
          title: 'pages.classifiers.types.countriesEdit',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
            {
              text: 'pages.classifiers.types.countries',
              to: { name: 'classifierCountries', state: { restorePaging: true } },
            },
          ],
        },
        component: () => import('@/views/classifiers/countries/Edit.vue'),
      },
      {
        path: '/classifiers/countries/:itemCode/view',
        name: 'countryView',
        meta: {
          title: 'pages.classifiers.types.country',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
            {
              text: 'pages.classifiers.types.countries',
              to: { name: 'classifierCountries', state: { restorePaging: true } },
            },
          ],
        },
        component: () => import('@/views/classifiers/countries/View.vue'),
      },
      {
        path: '/classifiers/countries/new',
        name: 'countryNew',
        meta: {
          title: 'pages.classifiers.types.countryNew',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.admin.title',
              to: { name: 'admin' },
            },
            {
              text: 'pages.classifiers.title',
              to: { name: 'classifiers' },
            },
            {
              text: 'pages.classifiers.types.countries',
              to: { name: 'classifierCountries', state: { restorePaging: true } },
            },
          ],
        },
        component: () => import('@/views/classifiers/countries/New.vue'),
      },
      // Gājienu plānošana
      {
        path: '/march',
        name: 'march',
        meta: {
          title: 'pages.march.title',
          state: 'authorized',
        },
        component: () => import('@/views/registries/march/List.vue'),
      },
      {
        path: '/march/:itemCode/view',
        name: 'marchCollectiveView',
        meta: {
          title: 'pages.march.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.march.title',
              to: { name: 'march' },
            },
          ],
        },
        component: () => import('@/views/registries/march/View.vue'),
      },
      {
        path: '/march/:itemCode/edit',
        name: 'marchCollectiveEdit',
        meta: {
          title: 'pages.march.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.march.title',
              to: { name: 'march' },
            },
          ],
        },
        component: () => import('@/views/registries/march/Edit.vue'),
      },
      {
        path: '/march/new',
        name: 'marchCollectiveNew',
        meta: {
          title: 'pages.march.newTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.march.title',
              to: { name: 'march' },
            },
          ],
        },
        component: () => import('@/views/registries/march/New.vue'),
      },
      // Personas
      {
        path: '/persons',
        name: 'persons',
        meta: {
          title: 'pages.persons.title',
          state: 'authorized',
        },
        component: () => import('@/views/registries/persons/List.vue'),
      },
      {
        path: '/persons/duplicates',
        name: 'personDuplicates',
        meta: {
          title: 'pages.persons.duplicates.title',
          state: 'authorized',
        },
        component: () => import('@/views/registries/persons/DuplicatesList.vue'),
      },
      {
        path: '/persons/new',
        name: 'personsNew',
        meta: {
          title: 'pages.persons.newPersonTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.persons.title',
              to: {
                name: 'persons',
                state: { restorePaging: true },
              },
            },
          ],
        },
        component: () => import('@/views/registries/persons/New.vue'),
      },
      {
        path: '/persons/:itemCode/edit',
        name: 'personEdit',
        meta: {
          title: 'pages.persons.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.persons.title',
              to: {
                name: 'persons',
                state: { restorePaging: true },
              },
            },
          ],
        },
        component: () => import('@/views/registries/persons/Edit.vue'),
      },
      {
        path: '/persons/:itemCode/view',
        name: 'personView',
        meta: {
          title: 'pages.persons.viewTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.persons.title',
              to: {
                name: 'persons',
                state: { restorePaging: true },
              },
            },
          ],
        },
        component: () => import('@/views/registries/persons/View.vue'),
      },

      // Organizācijas
      {
        path: '/organizations',
        name: 'organizations',
        meta: {
          title: 'pages.organizations.title',
          state: 'authorized',
        },
        component: () => import('@/views/registries/collectives/List.vue'),
      },
      {
        path: '/organizations/new',
        name: 'organizationsNew',
        meta: {
          title: 'pages.organizations.newTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.organizations.title',
              to: { name: 'organizations' },
            },
          ],
        },
        component: () => import('@/views/registries/collectives/New.vue'),
      },
      {
        path: '/organizations/:itemCode/edit',
        name: 'organizationEdit',
        meta: {
          title: 'pages.organizations.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.organizations.title',
              to: { name: 'organizations' },
            },
          ],
        },
        component: () => import('@/views/registries/collectives/Edit.vue'),
      },
      {
        path: '/organizations/:itemCode/view',
        name: 'organizationView',
        meta: {
          title: 'pages.organizations.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.organizations.title',
              to: { name: 'organizations' },
            },
          ],
        },
        component: () => import('@/views/registries/collectives/View.vue'),
      },

      // Kolektīvi
      {
        path: '/collectives',
        name: 'collectives',
        meta: {
          title: 'pages.collectives.title',
          state: 'authorized',
        },
        component: () => import('@/views/registries/collectives/List.vue'),
      },
      {
        path: '/collectives/new',
        name: 'collectivesNew',
        meta: {
          title: 'pages.collectives.newTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.collectives.title',
              to: { name: 'collectives' },
            },
          ],
        },
        component: () => import('@/views/registries/collectives/New.vue'),
      },
      {
        path: '/collectives/:itemCode/edit',
        name: 'collectiveEdit',
        meta: {
          title: 'pages.collectives.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.collectives.title',
              to: {
                name: 'collectives',
                state: { restorePaging: true },
              },
            },
          ],
        },
        component: () => import('@/views/registries/collectives/Edit.vue'),
      },
      {
        path: '/collectives/:itemCode/view',
        name: 'collectiveView',
        meta: {
          title: 'pages.collectives.viewTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.collectives.title',
              to: {
                name: 'collectives',
                state: { restorePaging: true },
              },
            },
          ],
        },
        component: () => import('@/views/registries/collectives/View.vue'),
      },
      {
        path: '/collectives/:itemCode/view-old',
        name: 'collectiveViewOld',
        meta: {
          title: 'pages.collectives.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.collectives.title',
              to: {
                name: 'collectives',
                state: { restorePaging: true },
              },
            },
          ],
        },
        component: () => import('@/views/registries/collectives/ViewOld.vue'),
      },
      // Dalībnieki
      {
        path: '/collectives/:itemCode/participant/new',
        name: 'participantsNew',
        meta: {
          title: 'pages.participants.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.collectives.title',
              to: { name: 'collectives' },
            },
          ],
        },
        component: () => import('@/views/registries/participants/New.vue'),
      },
      {
        path: '/person/:personId/collective/new',
        name: 'participantsNewFromPersons',
        meta: {
          title: 'pages.participants.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.persons.title',
              to: { name: 'persons' },
            },
          ],
        },
        component: () => import('@/views/registries/participants/New.vue'),
      },
      {
        path: '/organizations/:itemCode/participant/new',
        name: 'participantsOrganizationNew',
        meta: {
          title: 'pages.participants.organizations.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.organizations.title',
              to: { name: 'organizations' },
            },
          ],
        },
        component: () => import('@/views/registries/participants/New.vue'),
      },
      {
        path: '/collectives/:itemCode/participant/:participantId/view',
        name: 'participantView',
        meta: {
          title: 'pages.participants.viewTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.collectives.title',
              to: { name: 'collectives' },
            },
          ],
        },
        component: () => import('@/views/registries/participants/View.vue'),
      },
      {
        path: '/organizations/:itemCode/participant/:participantId/view',
        name: 'participantOrganizationView',
        meta: {
          title: 'pages.participants.viewTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.organizations.title',
              to: { name: 'organizations' },
            },
          ],
        },
        component: () => import('@/views/registries/participants/View.vue'),
      },
      {
        path: '/collectives/:itemCode/participant/:participantId/edit',
        name: 'participantEdit',
        meta: {
          title: 'pages.participants.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.collectives.title',
              to: { name: 'collectives' },
            },
          ],
        },
        component: () => import('@/views/registries/participants/Edit.vue'),
      },
      {
        path: '/organizations/:itemCode/participant/:participantId/edit',
        name: 'participantOrganizationEdit',
        meta: {
          title: 'pages.participants.editTitle',
          state: 'authorized',
          breadcrumbs: [
            {
              text: 'pages.organizations.title',
              to: { name: 'organizations' },
            },
          ],
        },
        component: () => import('@/views/registries/participants/Edit.vue'),
      },
      //
      //
      {
        path: '/login/role',
        name: 'chooseRole',
        meta: { title: 'pages.loginPickRole.title', state: ['req_role'] },
        component: () => import('@/views/util/ChooseRole.vue'),
      },
      {
        path: '/role/change',
        name: 'changeRole',
        meta: { title: 'pages.loginPickRole.title', state: 'authorized' },
        component: () => import('@/views/util/ChooseRole.vue'),
      },
      {
        path: '/profile/view',
        name: 'myPersonView',
        meta: { title: 'pages.persons.profileTitle', state: 'authorized' },
        component: () => import('@/views/registries/persons/View.vue'),
      },
      {
        path: '/profile/edit',
        name: 'myPersonEdit',
        meta: { title: 'pages.persons.profileEditTitle', state: 'authorized' },
        component: () => import('@/views/registries/persons/Edit.vue'),
      },
      {
        path: '/login/organization',
        name: 'chooseOrganization',
        meta: {
          title: 'pages.loginPickInstitution.title',
          state: 'req_organization',
        },
        component: () => import('@/views/util/ChooseInstitution.vue'),
      },
      {
        path: '/login/agreement',
        name: 'userAgreement',
        meta: {
          title: 'pages.userAgreement.title', // 'pages.userAgreement.title' // todo sveiciens, lietotāja vienošanās
          state: 'req_agreement',
        },
        component: () => import('@/views/util/Agreement.vue'),
      },
      {
        path: '/error',
        name: 'error',
        component: () => import('@/views/util/Error500.vue'),
        meta: { title: 'pages.error.title', anonymous: true },
      },
      {
        path: '/unauthorized',
        name: 'unauthorized',
        component: () => import('@/views/util/Unauthorized.vue'),
        meta: { title: 'pages.unauthorized.title', anonymous: true },
      },
      {
        path: '/unauthorized',
        name: 'notAuthorized',
        component: () => import('@/views/util/Unauthorized.vue'),
        meta: { title: 'pages.unauthorized.title', anonymous: true },
      },
      {
        path: '/session-ended',
        name: 'sessionEnded',
        component: () => import('@/views/util/SessionEnded.vue'),
        meta: { title: 'pages.sessionEnded.title', anonymous: true },
      },
      {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        alias: '/notFound',
        meta: { title: 'pages.notFound.title', anonymous: true },
        component: () => import('@/views/util/NotFound.vue'),
      },
      {
        path: '/not-found',
        name: 'notFoundStandalone',
        alias: '/notFound',
        meta: { title: 'pages.notFound.title', anonymous: true },
        component: () => import('@/views/util/NotFound.vue'),
      },
    ],
  },
  {
    path: '/auth-done',
    name: 'authDone',
    component: () => import('@/views/util/AuthDone.vue'),
    meta: { title: 'pages.auth.title', anonymous: true },
  },
  {
    path: '/auth/callback',
    name: 'authDone2',
    component: () => import('@/views/util/AuthDone.vue'),
    meta: { title: 'pages.auth.title', anonymous: true },
  },
  {
    path: '/done-auth',
    name: 'authDone3',
    component: () => import('@/views/util/AuthDone.vue'),
    meta: { title: 'pages.auth.title', anonymous: true },
  },
];

export default routes;
